import { LargeAmountPipe } from './large-amount.pipe';
import { CurrencyRoundingPipe } from './currency-rounding.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CdkTableModule } from '@angular/cdk/table';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSliderModule } from '@angular/material/slider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';

import { AccordionModule } from 'primeng/accordion';
import { MessageModule } from 'primeng/message';

// import { AutoCompleteModule } from 'primeng/primeng';

import { BlockUIModule } from 'primeng/blockui';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
// import { CarouselModule } from 'primeng/primeng';
// import { ChartModule } from 'primeng/primeng';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ContextMenuModule } from 'primeng/contextmenu';
// import { DataGridModule } from 'primeng/primeng';
// import { DataListModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
// import { DragDropModule } from 'primeng/primeng';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
// import { GalleriaModule } from 'primeng/primeng';
// import { GMapModule } from 'primeng/primeng';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { LightboxModule } from 'primeng/lightbox';
import { ListboxModule } from 'primeng/listbox';
// import { MegaMenuModule } from 'primeng/primeng';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OverlayPanelModule } from 'primeng/overlaypanel';
// import { PaginatorModule } from 'primeng/primeng';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
// import { PasswordModule } from 'primeng/primeng';
import { PickListModule } from 'primeng/picklist';
// import { ProgressBarModule } from 'primeng/primeng';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
// import { RatingModule } from 'primeng/primeng';
// import { ScheduleModule } from 'primeng/primeng';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';
// import { SlideMenuModule } from 'primeng/primeng';
import { SliderModule } from 'primeng/slider';
import { SpinnerModule } from 'primeng/spinner';
import { SplitButtonModule } from 'primeng/splitbutton';
// import { SplitterModule } from 'primeng/splitter';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SidebarModule } from 'primeng/sidebar';
// import { StepsModule } from 'primeng/primeng';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { TerminalModule } from 'primeng/terminal';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree'
import { SharedModule } from 'primeng/api';
import { TreeTableModule } from 'primeng/treetable';
import { TagModule } from 'primeng/tag';

import { AmChartsModule } from '@amcharts/amcharts3-angular';

import * as am4core from '@amcharts/amcharts4/core';
import am4themes_material from '@amcharts/amcharts4/themes/material';
am4core.useTheme(am4themes_material);

@NgModule({
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AccordionModule,
        // AutoCompleteModule,
        BlockUIModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CardModule,
        // CarouselModule,
        // ChartModule,
        CheckboxModule,
        ChipsModule,
        CodeHighlighterModule,
        ConfirmDialogModule,
        ConfirmPopupModule,
        SharedModule,
        ContextMenuModule,
        // DataGridModule,
        // DataListModule,
        // Deprecated? DataScrollerModule,
        TableModule,
        DialogModule,
        // DragDropModule,
        DropdownModule,
        EditorModule,
        FieldsetModule,
        FileUploadModule,
        // GalleriaModule,
        // GMapModule,
        // Deprecated? GrowlModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        LightboxModule,
        ListboxModule,
        // MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        OrderListModule,
        OverlayPanelModule,
        // PaginatorModule,
        PanelModule,
        PanelMenuModule,
        // PasswordModule,
        PickListModule,
        // ProgressBarModule,
        ProgressSpinnerModule,
        RadioButtonModule,
        // RatingModule,
        // ScheduleModule,
        ScrollPanelModule,
        SelectButtonModule,
        // SlideMenuModule,
        SliderModule,
        SpinnerModule,
        SplitButtonModule,
        // SplitterModule,
        SidebarModule,
        // StepsModule,
        TabMenuModule,
        TabViewModule,
        TerminalModule,
        TieredMenuModule,
        ToastModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        TagModule,

        AmChartsModule,
        FlexLayoutModule,

        MatIconModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatRadioModule,
        MatCardModule,
        MatChipsModule,
        MatSelectModule,
        MatSidenavModule,
        MatInputModule,
        MatMenuModule,
        MatTabsModule,
        MatTooltipModule,
        CdkTableModule,
        DragDropModule,
        MatTableModule,
        MatGridListModule,
        MatSliderModule,
        MatDialogModule,
        MatToolbarModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatSnackBarModule,
        MatProgressSpinnerModule,
        MatPaginatorModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatDividerModule,
        CurrencyRoundingPipe,
        LargeAmountPipe,
    ],
    declarations: [
        CurrencyRoundingPipe,
        LargeAmountPipe,
    ],
    providers: [
        ConfirmationService,
        MessageService,
    ],
})
export class UIModule {

}
